import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ERROR BOUNDARY] Caught error:', error, errorInfo);
    this.setState({ errorInfo });
    
    // Log to boot log if available
    if (window.__bootLog) {
      window.__bootLog.push('[REACT ERROR] ' + error.toString());
      window.__bootLog.push('[REACT STACK] ' + (errorInfo?.componentStack || 'N/A'));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#0a0a0a',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          fontFamily: 'system-ui, sans-serif'
        }}>
          <div style={{ maxWidth: '500px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '24px', marginBottom: '16px', color: '#f97316' }}>
              ⚠️ Something went wrong
            </h1>
            <p style={{ marginBottom: '16px', opacity: 0.7 }}>
              The app encountered an error. This might be a browser compatibility issue.
            </p>
            
            <div style={{
              background: '#1a1a1a',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '16px',
              textAlign: 'left',
              fontSize: '12px',
              overflow: 'auto',
              maxHeight: '200px'
            }}>
              <p style={{ color: '#f87171', marginBottom: '8px' }}>
                {this.state.error?.toString()}
              </p>
              {this.state.errorInfo?.componentStack && (
                <pre style={{ opacity: 0.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {this.state.errorInfo.componentStack}
                </pre>
              )}
            </div>
            
            <button
              onClick={() => {
                // Clear all storage and reload
                try {
                  localStorage.clear();
                  sessionStorage.clear();
                } catch (e) {}
                window.location.reload();
              }}
              style={{
                background: '#f97316',
                color: '#000',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginRight: '8px'
              }}
            >
              Reload App
            </button>
            
            <button
              onClick={() => {
                // Copy debug info
                const debugInfo = {
                  error: this.state.error?.toString(),
                  stack: this.state.errorInfo?.componentStack,
                  bootLog: window.__bootLog,
                  userAgent: navigator.userAgent,
                  url: window.location.href
                };
                navigator.clipboard?.writeText(JSON.stringify(debugInfo, null, 2));
                alert('Debug info copied to clipboard');
              }}
              style={{
                background: '#333',
                color: '#fff',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              Copy Debug Info
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
